import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  TextField,
  Button,
  Tabs,
  Tab,
  Stack,
  InputAdornment,
  Card,
  CardContent,
  Chip,
  Divider,
  Alert,
} from "@mui/material";
import React, { useMemo, useState } from "react";
import CommonLabel from "../../../components/label";
import CommonTextBox from "../../../components/TextBoxes/common-text-box";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
const experienceOptions = [
  {
    value: "best",
    label: "Best",
    description: "Loved the product and would recommend it.",
  },
  {
    value: "good",
    label: "Good",
    description: "Worked well and gave a positive experience.",
  },
  {
    value: "average",
    label: "Average",
    description: "Okay product, but not very impressive.",
  },
  {
    value: "bad",
    label: "Bad",
    description: "Did not work well or caused a poor experience.",
  },
];

const MyVanity = (props) => {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (_, newValue) => {
    setActiveTab(newValue);
  };
  const products = [];
  const [reviews, setReviews] = useState({});

  const handleExperienceSelect = (productId, experience) => {
    setReviews((prev) => ({
      ...prev,
      [productId]: {
        ...prev[productId],
        experience,
      },
    }));
  };

  return (
    <Dialog
      open={false}
      onClose={(e) => {
        console.log(e);
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogContent sx={{ p: { xs: 2, sm: 2.5 } }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <CommonLabel variant={"h6"}> Add Products</CommonLabel>
          <IconButton
            onClick={(e) => {
              console.log(e);
            }}
            size="small"
            aria-label="Close Popup"
            sx={{
              width: 30,
              height: 30,
              backgroundColor: "#fff",
              color: "black",
            }}
          >
            {" "}
            <CloseIcon sx={{ fontsize: 18 }} />{" "}
          </IconButton>
        </Box>

        {/* Tabs */}
        {/* <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "999px",
            p: "4px",
            mb: 2,
          }}
        >
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="fullwidth"
            TabIndicatorProps={{ sx: { display: "none" } }}
            sx={{
              minHeight: 34,
              "& .MuiTab-root": {
                minHeight: 34,
                textTransform: "none",
                fontSize: "12px",
                fontWeight: 500,
                color: "#6b7280",
                borderRadius: "999px",
              },
              "& .Mui-selected": {
                color: "#111827 !important",
                backgroundColor: "#ffffff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
              },}}
          >
            <Tab label="Product Details" />
            <Tab label="Share Review" />
          </Tabs>
          </Box>
           */}

        <Box sx={{ width: "100%", maxWidth: 600, p: 2 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="fullWidth" // Ensures tabs stretch evenly to fill the capsule
            sx={{
              backgroundColor: "#f1f1f1", // Light grey pill background
              borderRadius: "50px", // Creates the rounded pill look
              p: "4px", // Inner padding around the active tab
              minHeight: "48px",
              height: "48px",
              // Hide the default bottom line indicator completely
              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            <Tab
              label="Product Details"
              sx={{
                borderRadius: "40px", // Matches the pill shape
                textTransform: "none", // Prevents uppercase formatting
                fontWeight: 500,
                fontSize: "14px",
                color: "#757575", // Inactive text color
                minHeight: "40px",
                height: "40px",
                transition: "all 0.2s ease", // Smooth transition when toggling
                "&.Mui-selected": {
                  backgroundColor: "#ffffff", // White capsule for selected state
                  color: "#000000", // Active text color
                  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)", // Soft drop shadow
                },
              }}
            />
            <Tab
              label="Share Review"
              sx={{
                borderRadius: "40px",
                textTransform: "none",
                fontWeight: 500,
                fontSize: "14px",
                color: "#757575",
                minHeight: "40px",
                height: "40px",
                transition: "all 0.2s ease",
                "&.Mui-selected": {
                  backgroundColor: "#ffffff",
                  color: "#000000",
                  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
                },
              }}
            />
          </Tabs>
        </Box>
        {/* Product Details Tab */}

        {activeTab === 0 && (
          <Box component={"form"} noValidate>
            <Stack spacing={2}>
              <Box>
                <CommonLabel variant={"body2"}>Search Product</CommonLabel>
                <CommonTextBox />
              </Box>

              <Box>
                <CommonLabel variant={"body2"}>Product Expiry Date</CommonLabel>
                <CommonTextBox />
              </Box>

              <Box>
                <CommonLabel variant={"body2"}>Purchase Platform</CommonLabel>
                <CommonTextBox />
              </Box>
              <Box>
                <CommonLabel variant={"body2"}>Purchase Price</CommonLabel>
                <CommonTextBox />
              </Box>
              <Button
                fullWidth
                variant="contained"
                disabled={false}
                onClick={(e) => {
                  console.log(e);
                }}
                sx={{
                  mt: 0.5,
                  height: 42,
                  borderRadius: "8px",
                  textTransform: "none",
                  fontSize: "14px",
                  fontWeight: 700,
                  backgroundColor: "#111827",
                  "&:hover": {
                    backgroundColor: "#000000",
                  },
                  "&.Mui-disabled": {
                    color: "#ffffff",
                    backgroundColor: "#b9bcc2",
                  },
                }}
              >
                Continue
              </Button>
            </Stack>
          </Box>
        )}

        {activeTab === 1 && (
          <Box>
            {true ? (
              <Alert
                severity="info"
                sx={{
                  borderRadius: "10px",
                  fontSize: "13px",
                }}
              >
                No products added yet. Please add product details first.
              </Alert>
            ) : (
              <Stack spacing={1.5}>
                <Typography
                  sx={{
                    fontSize: "13px",
                    color: "#6b7280",
                    lineHeight: 1.5,
                  }}
                >
                  Share your real usage experience. This helps users understand
                  whether the product actually worked, instead of only showing a
                  star rating.
                </Typography>

                {products.map((product) => {
                  const selectedExperience = reviews[product.id]?.experience;
                  const reviewNote = reviews[product.id]?.note || "";

                  return (
                    <Card
                      key={product.id}
                      variant="outlined"
                      sx={{
                        borderRadius: "14px",
                        borderColor: "#eeeeee",
                        boxShadow: "0 8px 24px rgba(0,0,0,0.04)",
                      }}
                    >
                      <CardContent sx={{ p: 1.75 }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: 2,
                            mb: 1,
                          }}
                        >
                          <Box>
                            <Typography
                              sx={{
                                fontSize: "14px",
                                fontWeight: 700,
                                color: "#111827",
                              }}
                            >
                              {product.productName}
                            </Typography>

                            <Typography
                              sx={{
                                fontSize: "12px",
                                color: "#6b7280",
                                mt: 0.25,
                              }}
                            >
                              {product.purchasePlatform} • ₹
                              {product.purchasePrice}
                            </Typography>
                          </Box>

                          <Typography
                            sx={{
                              fontSize: "11px",
                              color: "#6b7280",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Exp: {formatDate(product.expiryDate)}
                          </Typography>
                        </Box>

                        <Divider sx={{ my: 1.25 }} />

                        <CommonLabel>
                          How was your product experience?
                        </CommonLabel>

                        <Stack
                          direction="row"
                          spacing={1}
                          useFlexGap
                          flexWrap="wrap"
                          sx={{ mt: 1 }}
                        >
                          {experienceOptions.map((option) => {
                            const isSelected =
                              selectedExperience === option.value;

                            return (
                              <Chip
                                key={option.value}
                                label={option.label}
                                clickable
                                onClick={() =>
                                  handleExperienceSelect(
                                    product.id,
                                    option.value,
                                  )
                                }
                                variant={isSelected ? "filled" : "outlined"}
                                sx={{
                                  height: 32,
                                  borderRadius: "999px",
                                  fontSize: "12px",
                                  fontWeight: 700,
                                  backgroundColor: isSelected
                                    ? "#111827"
                                    : "#ffffff",
                                  color: isSelected ? "#ffffff" : "#111827",
                                  borderColor: "#d1d5db",
                                  "&:hover": {
                                    backgroundColor: isSelected
                                      ? "#111827"
                                      : "#f9fafb",
                                  },
                                }}
                              />
                            );
                          })}
                        </Stack>

                        {selectedExperience && (
                          <Typography
                            sx={{
                              mt: 1,
                              fontSize: "12px",
                              color: "#6b7280",
                              lineHeight: 1.5,
                            }}
                          >
                            {
                              experienceOptions.find(
                                (item) => item.value === selectedExperience,
                              )?.description
                            }
                          </Typography>
                        )}

                        <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          value={reviewNote}
                          onChange={(event) =>
                            // handleReviewNoteChange(
                            //   product.id,
                            //   event.target.value,
                            // )
                            console.log(event)
                          }
                          placeholder="Write useful details like texture, result, side effects, value for money, smell, packaging, etc."
                          sx={{
                            mt: 1.5,
                            ...textFieldStyle,
                            "& .MuiInputBase-root": {
                              ...textFieldStyle["& .MuiInputBase-root"],
                              height: "auto",
                              alignItems: "flex-start",
                              py: 1,
                            },
                          }}
                        />

                        <Button
                          fullWidth
                          variant="contained"
                          disabled={!selectedExperience}
                          // onClick={() => handleSubmitReview(product)}
                          sx={{
                            mt: 1.5,
                            height: 38,
                            borderRadius: "8px",
                            textTransform: "none",
                            fontSize: "13px",
                            fontWeight: 700,
                            backgroundColor: "#111827",
                            "&:hover": {
                              backgroundColor: "#000000",
                            },
                            "&.Mui-disabled": {
                              color: "#ffffff",
                              backgroundColor: "#b9bcc2",
                            },
                          }}
                        >
                          Submit Review
                        </Button>
                      </CardContent>
                    </Card>
                  );
                })}
              </Stack>
            )}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

const formatDate = (dateValue) => {
  if (!dateValue) return "-";

  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(new Date(dateValue));
};

const textFieldStyle = {
  "& .MuiInputBase-root": {
    height: 42,
    borderRadius: "8px",
    fontSize: "13px",
    backgroundColor: "#ffffff",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#eeeeee",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#d1d5db",
  },
  "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#111827",
  },
  "& .MuiFormHelperText-root": {
    ml: 0,
    fontSize: "11px",
  },
};
export default MyVanity;
